module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_4_20_3.7bfdc508.jpeg";